module.exports = __webpack_public_path__ + "packs/media/images/badges/certificate-549085f16d406094a192ec17ea141aa7.png";